import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { fromCents } from '@shared/utils/src/price';
import { useCartContext } from '../../../../../context/cartContext';
import { useLocaleContext } from '../../../../../context/localeContext';
import { VerifyWithIDmeIcon } from '../../../../../icons';
import { getCurrencySymbol } from '../../../../../utils/currencyHelper';
import { Locale } from '../../../../../utils/internationalization/localeHelper';
import { IDmeTooltip } from '../IDmeTooltip/IDmeTooltip';
import { Container, DiscountAmount, IDmeButton } from './VerifyWithIDme.styles';

export function VerifyWithIDme() {
  const { t } = useTranslation('lib-global-common');
  const { locale } = useLocaleContext();
  const { asPath } = useRouter();
  const { miniCart } = useCartContext();
  const { idMeDiscount, currency } = { ...miniCart };

  const isUS = [Locale.EN_US].includes(locale);
  const isCheckout = asPath.includes('/checkout');
  const url =
    process.env.NEXT_PUBLIC_ENV_NAME === 'prod'
      ? 'https://hosted-pages.id.me/offers/clarks'
      : 'https://hosted-pages.id.me/offers/clarks-test';

  const openIDmeVerification = () => {
    window.open(
      url,
      '',
      `scrollbars\x3dyes,menubar\x3dno,status\x3dno,location\x3dno,toolbar\x3dno,width\x3d750,height\x3d780,top\x3d${
        (document.body.scrollHeight - 780) / 4
      },left\x3d${(document.body.scrollWidth - 750) / 2}`,
    );
  };

  if (idMeDiscount)
    return (
      <Container $spaceBetween>
        <Container>
          <span>{t('idme.discount.label')}</span>
          <IDmeTooltip />
        </Container>
        <DiscountAmount>
          {getCurrencySymbol(currency)}
          {fromCents(idMeDiscount)}
        </DiscountAmount>
      </Container>
    );

  if (!isUS || isCheckout) return null;

  return (
    <Container>
      <IDmeButton href={url} onClick={openIDmeVerification} target="_blank" rel="noopener noreferrer">
        <VerifyWithIDmeIcon role="img" aria-label={t('idme.verify.message')} />
      </IDmeButton>
      <IDmeTooltip />
    </Container>
  );
}
